module.exports = __webpack_public_path__ + "img/landing-painter1.d3002f20.png";